﻿
import { IAnalyticsService } from './IAnalyticsService';
import { MockAnalyticsService } from './mockAnalyticsService';
import { GoogleAnalyticsService } from './googleAnalyticsService';
import { appConfig } from '../../config/env';

export * from './IAnalyticsService';
export * from './mockAnalyticsService';
export * from './googleAnalyticsService';

const defaultAnalyticsInstance: IAnalyticsService =
  appConfig.analytics.gaMeasurementId?.trim()
    ? new GoogleAnalyticsService()
    : new MockAnalyticsService();

export function getAnalyticsService(): IAnalyticsService {
  return defaultAnalyticsInstance;
}
